// extracted by mini-css-extract-plugin
export default {"table":"TableList_table__M8EfR","table_scroll":"TableList_table_scroll__3FvgR"};